import { Button, GoogleSignInButton } from '@mm/components';
import { CloseIcon } from '@mm/icons';
import {
  EmailAccount,
  NewEmailAccount,
} from '@mm/state/interfaces/emailAccount';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useChannelConnection } from '../../../editor/features/beta/modules/Automations/AutomationEdit/InputTriggers/use-channel-connection';
import { EmailAccountEditor } from '../../../editor/features/beta/modules/Integrations/NativeIntegrations/components/EmailIntegrations/EmailAccountEditor';
import { useFreeTrialUpgradeModal } from '../FreeTrialUpgradeModal/use-free-trial-upgrade-modal';
import { CloseModalProps } from '../modal-helpers';
import styles from './ActivateEmailAccountModal.module.css';
import { InfoCircleFilled } from '@ant-design/icons';

export const ActivateEmailAccountModal = (props: CloseModalProps) => {
  const { closeModal } = props;
  const { connectChannel } = useChannelConnection(() => {});
  const { openFreeTrialUpgradeModalPromotional } = useFreeTrialUpgradeModal();

  const [emailAccountUnderEdit, setEmailAccountUnderEdit] = useState<
    NewEmailAccount | EmailAccount
  >();
  const hasNativeIntegrationsFeature = useSelector(
    combinedFeatureFlagsSelector,
  ).nativeIntegrations;

  const createNewManualAccount = () => {
    if (!hasNativeIntegrationsFeature) {
      openFreeTrialUpgradeModalPromotional();
      return;
    }
    setEmailAccountUnderEdit({
      name: '',
      emailAddress: '',
      kind: 'custom',
      credential: {
        smtpServerParams: {
          address: '',
          port: 465,
          userName: '',
          password: '',
          enableSsl: true,
        },
        incomingServerType: 'imap',
        incomingServerParams: {
          address: '',
          port: 993,
          userName: '',
          password: '',
          enableSsl: true,
        },
      },
    } as NewEmailAccount);
  };

  return (
    <div className={styles.container}>
      <CloseIcon
        className={styles.closeIcon}
        onClick={closeModal}
        color="#262626"
      />
      <div className={styles.heading}>Connect Your Email Account</div>

      <div className={styles.hint}>
        <InfoCircleFilled />
        Email accounts ending with @gmail.com are limited to 5 emails per day.
      </div>

      <p className={styles.hintFollowUp}>
        We encourage you to link a business email, such as a Google workspace
        email account, which is not limited in this way.
      </p>

      <div className={styles.buttons}>
        <GoogleSignInButton onClick={() => connectChannel('email')} />
        <Button
          size="md"
          color="secondary-blue"
          onClick={e => {
            e?.stopPropagation();
            createNewManualAccount();
          }}
          css={{ container: styles.secondaryButton }}
        >
          Connect Manually
        </Button>
      </div>
      <EmailAccountEditor
        emailAccountUnderEdit={emailAccountUnderEdit}
        onClose={closeModal}
      />
    </div>
  );
};
